/* eslint no-useless-escape:"off" */

import React, { Component } from 'react';

export default class Contact extends Component {
  /**
   * Initial state
   */

  constructor(props) {
    super(props);
    this.state = {
      isSubmitted: false,
      name: {
        value: '',
        error: '',
      },
      company: {
        value: '',
        error: '',
      },
      email: {
        value: '',
        error: '',
      },
      phone: {
        value: '',
        error: '',
      },
      message: {
        value: '',
        error: '',
      },
    };
    this.onChange = this.onChange.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  /**
   * Static methods
   */

  static validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  /**
   * Event handlers
   */

  onChange(event) {
    const field = event.target.id;
    const value = event.target.value;
    this.setState(prevState => {
      const nextState = JSON.parse(JSON.stringify(prevState));
      nextState[field].value = value;
      nextState[field].error = '';
      return nextState;
    });
  }

  onClose() {
    this.setState({
      isSubmitted: false,
    });
  }

  onSubmit() {
    const errors = {
      name: '',
      company: '',
      email: '',
      phone: '',
      message: '',
    };
    let errorsExist = false;
    if (this.state.name.value === '') {
      errorsExist = true;
      errors.name = 'Please enter your name';
    }
    if (this.state.email.value === '') {
      errorsExist = true;
      errors.email = 'Please enter your email address';
    } else if (!Contact.validateEmail(this.state.email.value)) {
      errorsExist = true;
      errors.email = 'Please enter a valid email address';
    }
    if (this.state.message.value === '') {
      errorsExist = true;
      errors.message = 'Please enter your message';
    }

    if (errorsExist) {
      this.setState(prevState => {
        const nextState = JSON.parse(JSON.stringify(prevState));
        nextState.name.error = errors.name;
        nextState.company.error = errors.company;
        nextState.email.error = errors.email;
        nextState.phone.error = errors.phone;
        nextState.message.error = errors.message;
        return nextState;
      });
    } else {
      const formData = new FormData();
      formData.append('name', this.state.name.value);
      formData.append('company', this.state.company.value);
      formData.append('email', this.state.email.value);
      formData.append('phone', this.state.phone.value);
      formData.append('message', this.state.message.value);
      fetch('http://api.grantnaylor.co.uk/contact-us.cfm', {
        method: 'POST',
        body: formData,
      });
      this.setState({
        isSubmitted: true,
      });
    }
  }

  /**
   * Render methods
   */

  renderSubmitted() {
    return (
      <div className="container my-5 text-center">
        <h1 className="text-700">THANKS</h1>
        <div>
          Thank you for your message or enquiry. We&#39;ll be in touch soon!
        </div>
        <button
          className="btn btn-secondary shadow mt-3 px-4"
          onClick={this.onClose}
        >
          Close
        </button>
      </div>
    );
  }

  render() {
    if (this.state.isSubmitted) {
      return this.renderSubmitted();
    }

    return (
      <div className="container my-5">
        <div className="row">
          <div className="col-md-8 offset-md-2 col-sm-12">
            <a name="contact" />
            <h1 className="text-700 mb-4">CONTACT US</h1>
            <h2 className="text-500 mb-3">Email</h2>
            <div className="mb-4">
              Please complete the details below if you want to get in touch.
              Mandatory fields are marked with an asterisk (*).
            </div>
            <div className="form-group">
              <label htmlFor="name">Name (*)</label>
              <input
                type="text"
                className="form-control shadow"
                id="name"
                placeholder="Enter your name"
                value={this.state.name.value}
                onChange={this.onChange}
              />
              {this.state.name.error !== '' && (
                <small className="form-text text-danger">
                  {this.state.name.error}
                </small>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="company">Company</label>
              <input
                type="text"
                className="form-control shadow"
                id="company"
                placeholder="Enter your company name"
                value={this.state.company.value}
                onChange={this.onChange}
              />
              {this.state.company.error !== '' && (
                <small className="form-text text-danger">
                  {this.state.company.error}
                </small>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="email">Email (*)</label>
              <input
                type="text"
                className="form-control shadow"
                id="email"
                placeholder="Enter your email address"
                value={this.state.email.value}
                onChange={this.onChange}
              />
              {this.state.email.error !== '' && (
                <small className="form-text text-danger">
                  {this.state.email.error}
                </small>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input
                type="text"
                className="form-control shadow"
                id="phone"
                placeholder="Enter your phone number"
                value={this.state.phone.value}
                onChange={this.onChange}
              />
              {this.state.phone.error !== '' && (
                <small className="form-text text-danger">
                  {this.state.phone.error}
                </small>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="message">Message (*)</label>
              <textarea
                className="form-control shadow"
                id="message"
                rows="3"
                onChange={this.onChange}
                value={this.state.message.value}
                placeholder="Enter your message"
              />
              {this.state.message.error !== '' && (
                <small className="form-text text-danger">
                  {this.state.message.error}
                </small>
              )}
            </div>
            <button
              className="btn btn-secondary shadow mt-3 px-4"
              onClick={this.onSubmit}
            >
              Submit
            </button>
            <div className="mt-3 mb-4">
              <small>
                Please note that regretfully we cannot currently accept
                unsolicited scripts for consideration.
              </small>
            </div>
            <h2 className="text-500 mb-3">Post</h2>
            <div className="mb-4">
              You can also write to us at the following address:
            </div>
            <div className="mb-4">
              Grant Naylor Productions, c/o YMU, 180 Great Portland Street, London W1W 5QZ
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Contact.jsx